// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bK9C","option":"styles_option__1Zvqk","active":"styles_active__3OWAX"};